module.exports = __webpack_public_path__ + "static/media/pin.76f42853.png";